import '@commons/polyfills';
import '@commons/reset';
import '@commons/general';
import '@commons/header';
import '@commons/utils';

import processesTable from '@modules/processesTable';
import carousel from '@modules/carousel';
import lightBox from '@modules/lightBox';
import swiper from '@modules/swiper';

import '@styles/layouts/l-spec-boxes.scss';
import '@styles/layouts/l-processes-table.scss';
import '@styles/layouts/l-spec-tables.scss';

import '@styles/components/c-product-summary.scss';
import '@styles/components/c-product-overview.scss';
import '@styles/components/c-price-box.scss';
import '@styles/components/c-dot.scss';
import '@styles/components/c-species-info.scss';
import '@styles/components/c-spec-box.scss';
import '@styles/components/c-processes-table.scss';
import '@styles/components/c-product-lengths.scss';
import '@styles/components/c-spec-table.scss';
import '@styles/components/c-downloads.scss';
import '@styles/components/c-species-groups.scss';
import '@styles/components/c-product-grid.scss';
import '@styles/components/c-category-grid.scss';
import '@styles/components/c-product-table.scss';
import '@styles/components/c-product-filter.scss';
import '@styles/components/c-available-in.scss';
import '@styles/components/c-available-profiles.scss';
import '@styles/components/c-product-image.scss';
import '@styles/components/c-product-details.scss';
import '@styles/components/c-related-products.scss';
import '@styles/components/c-image-call-to-action.scss';
import '@styles/components/c-cladding-what-to-expect.scss';
export default function init() {
  processesTable();
  carousel();
  lightBox();
  swiper();
}

init();
